import { generateExample } from '#environment/index.js';
import { removeUndefined } from '../../utils/objects.js';
import BaseField from './BaseField.js';
const DEFAULT_TYPE = 'number';
const DEFAULT_FORMAT = {
    number: 'double',
    integer: 'int32',
};
class NumberField extends BaseField {
    numberType;
    format;
    default;
    multipleOf;
    minimum;
    exclusiveMinimum;
    maximum;
    exclusiveMaximum;
    constructor(data) {
        super({
            ...data,
            example: data.example ?? data.default,
        });
        this.numberType = data.numberType;
        this.format = data.format || DEFAULT_FORMAT[this.numberType];
        this.default = data.default;
        this.multipleOf = data.multipleOf;
        this.minimum = data.minimum;
        this.exclusiveMinimum = data.exclusiveMinimum;
        this.maximum = data.maximum;
        this.exclusiveMaximum = data.exclusiveMaximum;
        this.proto.type = this.format;
    }
    getExample(_transport) {
        if (this.example === undefined) {
            this.example = generateExample({
                format: this.format,
                multipleOf: this.multipleOf,
                minimum: this.minimum,
                exclusiveMinimum: this.exclusiveMinimum,
                maximum: this.maximum,
                exclusiveMaximum: this.exclusiveMaximum,
                type: this.numberType,
            });
        }
        return this.example;
    }
    toSchema(transport, options) {
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: this.numberType,
            default: this.default,
            format: this.format,
            multipleOf: this.multipleOf,
            minimum: this.minimum,
            exclusiveMinimum: this.exclusiveMinimum,
            maximum: this.maximum,
            exclusiveMaximum: this.exclusiveMaximum,
        });
    }
    fromJSON(input) {
        return input;
    }
}
export { DEFAULT_TYPE, };
export default NumberField;
//# sourceMappingURL=NumberField.js.map